// extracted by mini-css-extract-plugin
export default {"dateSeparator":"MVXgxNqp10XGNeLE0AHT"};